import gql from 'graphql-tag';
export const KinderConnectCaptureRequiredForLeaves = gql `
    query KinderConnectCaptureRequiredForLeaves($childIds: [ChildId!]!) {
        childrenLeaves {
            kinderConnectCaptureRequired(childIds: $childIds)
        }
    }
`;
